import React from "react";
import Tag from "./Tag";
import dayjs from "dayjs";

interface StatusCardProps {
  title: string;
  date: string;
  statusId: number;
  assessmentType: string;
  tagBackgroundColor?: string;
  tagTextColor?: string;
  onClick?: () => void;
  className?: string;
}

const StatusCard: React.FC<StatusCardProps> = ({
  title,
  date,
  statusId,
  assessmentType,
  tagBackgroundColor,
  tagTextColor,
  onClick,
  className = "",
}) => {
  const cardClasses = [
    "status-card",
    `status-${statusId}`,
    onClick ? "clickable" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const getFormattedDate = (plannedDate: string) => {
    if (dayjs(plannedDate).isValid) {
      const date = dayjs(plannedDate).format("DD-MMM-YYYY");
      return date !== "Invalid Date" ? date : "";
    }
    return "";
  };

  return (
    <div className={cardClasses}>
      {/* Top Section - Title and Tag */}
      <div className="status-card-top-section">
        {/* Title */}
        <div className="status-card-title truncate-ai-heading" title={title}>
          {title}
        </div>

        {/* Tag */}
        <Tag
          text={assessmentType}
          backgroundColor={tagBackgroundColor}
          textColor={tagTextColor}
        />
      </div>

      {/* Bottom Section - Date */}
      <div className="status-card-bottom-section">
        <div className="status-card-date">{getFormattedDate(date)}</div>
      </div>
    </div>
  );
};

export default StatusCard;
